import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InvestmentValidationService } from '../../services/investmentValidation/investmentValidation.service';

@Component({
  selector: 'app-detail-real-estate',
  templateUrl: './detail-real-estate.component.html',
  styleUrls: ['./detail-real-estate.component.css']
})
export class DetailRealEstateComponent implements OnInit {
  @Input() info: any | undefined;
  @Input() cantInvest: boolean = true;
  @Output() closeDetailOpenInvest = new EventEmitter<string>();
  keys: any[] | undefined;
  images: string[] | undefined;
  eurosSold: number = 0;
  userInversor: boolean = false;
  percentageToPrivateSale: number = 0;
  
  // Variables para manejar ambos formatos
  isMultipleVivienda: boolean = false;
  viviendas: any[] | undefined;

  constructor(
    private crf: ChangeDetectorRef,
    public dialogRef: MatDialogRef<DetailRealEstateComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private invesmentValidationService: InvestmentValidationService
  ) {
    this.info = data.info;
    this.cantInvest = data.cantInvest;
    this.eurosSold = data.eurosSold || 0;
    this.userInversor = data.userInversor || false;
    this.percentageToPrivateSale = data.percentageToPrivateSale || 0;
  }

  closeOpen() {
    this.closeDetailOpenInvest.emit(this.info.id);
    this.dialogRef.close();
  }

  invest(){
    // Llama al servicio para validar la inversión
    const isValid = this.invesmentValidationService.validateInvestment(
      this.info,
      this.eurosSold,
      this.userInversor,
      this.percentageToPrivateSale
    );
    
    if (isValid) {
      // Si la validación es exitosa, cierra el modal y navega a la ruta de inversión
      this.closeDetailOpenInvest.emit(this.info.id);
      this.dialogRef.close();
      this.router.navigate(['/oportunidad'], { queryParams: { id: this.info.id } });
    }
    // Si no es válida, el servicio ya se encarga de mostrar el mensaje correspondiente
  }

  transformDecimals(num: number) {
    const numberFormated = new Intl.NumberFormat('de-DE').format(num);
    return numberFormated;
  }

  getUriIframeGoogle(iframe: string) {
    if (!iframe) return '';
    let googleUrl: any = iframe;
    googleUrl = googleUrl.replace('<iframe src="', '');
    googleUrl = googleUrl.split('" width');
    return googleUrl[0];
  }

  goPolyscan(sellerAddress: string) {
    window.open(`https://polygonscan.com/address/${sellerAddress}`, '_blank');
  }

  // Método para obtener las claves de los atributos de una vivienda
  getViviendaKeys(atributos: any): string[] {
    if (!atributos || typeof atributos !== 'object') {
      return [];
    }
    return Object.keys(atributos);
  }

  ngOnInit(): void {
    // Determinar el tipo de proyecto basado en isMultipleVivienda
    this.isMultipleVivienda = this.info.isMultipleVivienda === true;

    if (this.isMultipleVivienda) {
      // Proyecto con viviendas múltiples
      this.viviendas = this.info.viviendas || [];
    } else {
      // Proyecto con atributos únicos (formato antiguo)
      if (this.info.attributes) {
        this.keys = Object.keys(this.info.attributes);
      }
    }

    // Cargar imágenes
    let imgs: any[] = [];
    if (this.info.images) {
      this.info.images.forEach((url: string) => {
        imgs.push(url)
      });
      (imgs.length > 0) ? this.images = imgs : null;
    }

    this.crf.detectChanges();
  }
}
